/* tslint:disable */
/* eslint-disable */
/**
 * Hey Pharamcist API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { FieldValidation } from './field-validation';
/**
 * 
 * @export
 * @interface ServiceFormField
 */
export interface ServiceFormField {
  _id?: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceFormField
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceFormField
     */
    type: ServiceFormFieldTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ServiceFormField
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceFormField
     */
    placeholder?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ServiceFormField
     */
    required: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ServiceFormField
     */
    options?: Array<string>;
    /**
     * 
     * @type {FieldValidation}
     * @memberof ServiceFormField
     */
    validation?: FieldValidation;
}

/**
    * @export
    * @enum {string}
    */
export enum ServiceFormFieldTypeEnum {
    Text = 'text',
    Email = 'email',
    Phone = 'phone',
    Select = 'select',
    Radio = 'radio',
    Checkbox = 'checkbox',
    Textarea = 'textarea',
    Date = 'date',
    Time = 'time'
}

